import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { OrderSummaryModule } from '../../../components/order-summary/order-summary.module';
import { ProductListMiniModule } from '../../../components/product-list-mini/product-list-mini.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { BuyButtonSummaryLayout } from '../buy-button-wrapper.model';
import { BehaviorSubject, combineLatest, merge, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetDirective } from '@ngrx/component';

@Component({
  selector: 'orderform-buy-summary',
  templateUrl: './buy-summary.component.html',
  styleUrls: ['./buy-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    NgTemplateOutlet,
    OrderSummaryModule,
    ProductListMiniModule,
    DirectivesModule,
    NgClass,
    LetDirective,
  ],
})
export class BuySummaryComponent {
  private _originLayout: BuyButtonSummaryLayout = 'horizontal';

  private _layout$ = new BehaviorSubject<BuyButtonSummaryLayout>(this._originLayout);

  @Input() set layout(type: BuyButtonSummaryLayout) {
    this._originLayout = type;
    this._layout$.next(type);
  }

  @Input() allowAutoLayoutChange = false;

  @Input() expressCheckoutMode = false;

  private _innerContainerClasses$ = new ReplaySubject<string>(1);
  @Input() set innerContainerClasses(str: string) {
    this._innerContainerClasses$.next(str);
  }

  private _outerContainerClasses$ = new ReplaySubject<string>(1);
  @Input() set outerContainerClasses(str: string) {
    this._outerContainerClasses$.next(str);
  }

  private _title$ = new ReplaySubject<string>(1);
  @Input() set title(str: string) {
    this._title$.next(str);
  }

  public vm$ = combineLatest([
    this._layout$,
    this._innerContainerClasses$,
    this._outerContainerClasses$,
    this._title$,
  ]).pipe(
    map(([layout, innerContainerClasses, outerContainerClasses, title]) => {
      return {
        layout,
        innerContainerClasses,
        outerContainerClasses,
        title,
      };
    })
  );

  onCountProductsChange(productCount: number) {
    const layout = productCount <= 2 && this.allowAutoLayoutChange ? 'vertical' : this._originLayout;
    this._layout$.next(layout);
  }
}
